import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, withKeys as _withKeys, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "tutorial-bs-header" };
const _hoisted_2 = { class: "tutorial-bs-header-content" };
const _hoisted_3 = { class: "tutorial-bs-title" };
const _hoisted_4 = { class: "tutorial-bs-subtitle text-muted small mb-0" };
const _hoisted_5 = { class: "tutorial-bs-body" };
const _hoisted_6 = {
    key: 0,
    class: "tutorial-video-wrap"
};
const _hoisted_7 = { class: "tutorial-video-container" };
const _hoisted_8 = ["src", "title"];
const _hoisted_9 = {
    key: 1,
    class: "tutorial-resources"
};
const _hoisted_10 = {
    key: 0,
    class: "tutorial-guide-list",
    "aria-label": "Guías interactivas"
};
const _hoisted_11 = { class: "tutorial-guide-card-content" };
const _hoisted_12 = { class: "tutorial-guide-card-title" };
const _hoisted_13 = {
    key: 0,
    class: "tutorial-guide-card-text"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
    key: 0,
    class: "tutorial-list-heading"
};
const _hoisted_16 = ["onClick", "onKeydown"];
const _hoisted_17 = { class: "tutorial-card-thumb" };
const _hoisted_18 = ["src", "alt"];
const _hoisted_19 = { class: "tutorial-card-title" };
import { computed, ref, watch } from "vue";
import { getYoutubeThumb, } from "@/composables/useContextualTutorials";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TutorialHelpBottomSheet',
    props: {
        show: { type: Boolean },
        demos: {},
        guides: {}
    },
    emits: ["close", "start-guide"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const guides = computed(() => props.guides ?? []);
        const selectedDemo = ref(null);
        const seleccionarDemo = (demo) => {
            selectedDemo.value = demo;
        };
        const volverAlListado = () => {
            selectedDemo.value = null;
        };
        const cerrar = () => {
            selectedDemo.value = null;
            emit("close");
        };
        const iniciarGuia = (guideId) => {
            selectedDemo.value = null;
            emit("start-guide", guideId);
            emit("close");
        };
        watch(() => props.show, (visible) => {
            if (!visible) {
                selectedDemo.value = null;
                return;
            }
            if (props.demos.length === 1 && guides.value.length === 0) {
                selectedDemo.value = props.demos[0] ?? null;
            }
            else {
                selectedDemo.value = null;
            }
        });
        watch(() => props.demos, (demos) => {
            if (!props.show)
                return;
            if (demos.length === 1 && guides.value.length === 0) {
                selectedDemo.value = demos[0] ?? null;
                return;
            }
            if (selectedDemo.value &&
                !demos.some((demo) => demo.id === selectedDemo.value?.id)) {
                selectedDemo.value = null;
            }
        });
        return (_ctx, _cache) => {
            return (_ctx.show)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "tutorial-bs-overlay",
                    onClick: cerrar
                }, [
                    _createElementVNode("div", {
                        class: "tutorial-bs",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                    }, [
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "tutorial-bs-handle" }, null, -1)),
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                (selectedDemo.value && _ctx.demos.length > 1)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "tutorial-bs-back",
                                        "aria-label": "Volver al listado",
                                        onClick: volverAlListado
                                    }, _cache[1] || (_cache[1] = [
                                        _createElementVNode("i", {
                                            class: "bi bi-arrow-left",
                                            "aria-hidden": "true"
                                        }, null, -1)
                                    ])))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", null, [
                                    _createElementVNode("h5", _hoisted_3, _toDisplayString(selectedDemo.value
                                        ? selectedDemo.value.titulo
                                        : guides.value.length
                                            ? "Ayuda en esta pantalla"
                                            : "Videos tutoriales"), 1),
                                    _createElementVNode("p", _hoisted_4, _toDisplayString(selectedDemo.value
                                        ? selectedDemo.value.descripcion
                                        : guides.value.length
                                            ? "Elige una guía interactiva o un video para esta pantalla"
                                            : "Selecciona un video para esta pantalla"), 1)
                                ])
                            ]),
                            _createElementVNode("button", {
                                type: "button",
                                class: "tutorial-bs-close",
                                "aria-label": "Cerrar",
                                onClick: cerrar
                            }, _cache[2] || (_cache[2] = [
                                _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
                            ]))
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            (selectedDemo.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("iframe", {
                                            src: selectedDemo.value.videoUrl,
                                            title: selectedDemo.value.titulo,
                                            frameborder: "0",
                                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                            allowfullscreen: ""
                                        }, null, 8, _hoisted_8)
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    (guides.value.length)
                                        ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guides.value, (guide) => {
                                                return (_openBlock(), _createElementBlock("article", {
                                                    key: guide.id,
                                                    class: "tutorial-guide-card"
                                                }, [
                                                    _createElementVNode("div", _hoisted_11, [
                                                        _cache[3] || (_cache[3] = _createElementVNode("div", {
                                                            class: "tutorial-guide-card-icon",
                                                            "aria-hidden": "true"
                                                        }, [
                                                            _createElementVNode("i", { class: "bi bi-signpost-split" })
                                                        ], -1)),
                                                        _createElementVNode("div", null, [
                                                            _createElementVNode("h6", _hoisted_12, _toDisplayString(guide.title), 1),
                                                            (guide.description)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(guide.description), 1))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ]),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "tutorial-guide-card-cta",
                                                        onClick: ($event) => (iniciarGuia(guide.id))
                                                    }, " Muéstrame cómo ", 8, _hoisted_14)
                                                ]));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true),
                                    (_ctx.demos.length)
                                        ? (_openBlock(), _createElementBlock("section", {
                                            key: 1,
                                            class: _normalizeClass(["tutorial-list", { 'tutorial-list--with-guides': guides.value.length }]),
                                            role: "list",
                                            "aria-label": "Videos tutoriales"
                                        }, [
                                            (guides.value.length)
                                                ? (_openBlock(), _createElementBlock("h6", _hoisted_15, "Videos"))
                                                : _createCommentVNode("", true),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demos, (demo) => {
                                                return (_openBlock(), _createElementBlock("article", {
                                                    key: demo.id,
                                                    class: "tutorial-card",
                                                    role: "listitem",
                                                    tabindex: "0",
                                                    onClick: ($event) => (seleccionarDemo(demo)),
                                                    onKeydown: _withKeys(($event) => (seleccionarDemo(demo)), ["enter"])
                                                }, [
                                                    _createElementVNode("div", _hoisted_17, [
                                                        _createElementVNode("img", {
                                                            src: _unref(getYoutubeThumb)(demo.videoUrl),
                                                            alt: demo.titulo
                                                        }, null, 8, _hoisted_18),
                                                        _cache[4] || (_cache[4] = _createElementVNode("span", {
                                                            class: "tutorial-card-play",
                                                            "aria-hidden": "true"
                                                        }, "▶", -1))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_19, _toDisplayString(demo.titulo), 1)
                                                ], 40, _hoisted_16));
                                            }), 128))
                                        ], 2))
                                        : _createCommentVNode("", true)
                                ]))
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
